import { useQuery } from '@tanstack/vue-query'
import { propertyKeys } from './propertyQueryKeys'
import { getPropertyStatusCounts } from './propertyEndpoints'
import { parsePropertyStatusCounts } from './propertyParser'

// The five quick-filter counts, over the seller's whole portfolio.
export function usePropertyStatusCountsQuery() {
  return useQuery({
    queryKey: propertyKeys.statusCounts(),
    queryFn: () => getPropertyStatusCounts().then(parsePropertyStatusCounts),
  })
}
